import { DrawerAutoDataList, IDrawerDataListColumn, useCrudEntity } from "@dgs/core";
import { UserCreateDto, UserListDto, UserUpdateDto } from "apiGen";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { usersService } from "~shared/api/users";
import { IUserFormState, UserCreateDrawer, UserUpdateDrawer } from "./UserDrawer";

const mapToRequest = ({ roles, ...employee }: IUserFormState): UserCreateDto | UserUpdateDto => ({
	...employee,
	roleIds: roles.map((x) => x.id),
});

export const UserListPage: FC = () => {
	const { t } = useTranslation();
	const crudOperations = useCrudEntity(usersService, {
		entityName: t("User"),
		messages: {
			create: t("User was saved."),
			update: t("User was saved."),
			delete: t("User was deleted."),
		},
	});

	const dataListColumns: IDrawerDataListColumn<UserListDto>[] = [
		{
			heading: t("First name"),
			valueKey: "firstName",
			type: "value",
		},
		{
			heading: t("Last name"),
			valueKey: "lastName",
			type: "value",
		},
		{
			heading: t("Email"),
			valueKey: "email",
			type: "value",
		},
		{
			heading: t("Roles"),
			valueKey: "roles",
			render: ({ roles }) => roles.map((x) => x.name).join(", "),
			type: "value",
		},
	];

	return (
		<DrawerAutoDataList
			canCreate
			canUpdate={true}
			columns={dataListColumns}
			service={usersService}
			renderCreateDrawer={(drawerProps) => (
				<UserCreateDrawer
					{...drawerProps}
					onSubmit={(entityFormState) => crudOperations.createEntity(mapToRequest(entityFormState))}
				/>
			)}
			renderUpdateDrawer={(drawerProps) => {
				return (
					<UserUpdateDrawer
						{...drawerProps}
						onSubmit={(entityFormState) => crudOperations.updateEntity(drawerProps.id, mapToRequest(entityFormState))}
					/>
				);
			}}
			translations={{
				title: t("Users"),
				empty: t("No users available"),
			}}
		/>
	);
};
